/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRateApartment = {
    name?: string;
    roomType?: TileRateApartment.roomType;
    size?: number;
    singleBeds?: number;
    doubleBeds?: number;
};
export namespace TileRateApartment {
    export enum roomType {
        ROOM = 'room',
        SUITE = 'suite',
        APARTMENT = 'apartment',
        COMPLETE = 'complete',
    }
}
